import isEqual from 'lodash/isEqual';
import { sessionConstants } from '../constants/session.constants';

export function sessions(
  state = {
    sessions: [],
    selectedSession: {},
    totalSessions: 0,
  },
  action,
) {
  switch (action.type) {
    case sessionConstants.GETALL_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case sessionConstants.GETALL_SUCCESS: {
      const { attributes, data, totalCount } = action.sessions;
      return {
        ...state,
        columns: attributes,
        data,
        totalSessions: totalCount,
        isLoading: false,
      };
    }
    case sessionConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };

    case sessionConstants.DELETE_REQUEST:
      return {
        ...state,
      };
    case sessionConstants.DELETE_SUCCESS:
      const { id } = action;
      const { data } = state;
      const filteredTreatments = data.filter((item) => item.id !== id);
      return {
        ...state,
        data: filteredTreatments,
      };
    case sessionConstants.DELETE_FAILURE:
      return {
        ...state,
        error: true,
      };

    case sessionConstants.COUNT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case sessionConstants.COUNT_SUCCESS: {
      return {
        ...state,
        totalSessions: action.count,
      };
    }
    case sessionConstants.COUNT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };

    case sessionConstants.GET_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case sessionConstants.GET_SUCCESS:
      return {
        ...state,
        selectedSession: action.session,
        isLoading: false,
      };
    case sessionConstants.GET_FAILURE:
      return {
        ...state,
        error: true,
      };

    case sessionConstants.UPDATE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case sessionConstants.UPDATE_SUCCESS:
      return {
        ...state,
        selectedSession: action.session,
        isLoading: false,
      };
    case sessionConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: true,
      };

    case sessionConstants.REASSIGN_SUCCESS:
      const { clientId, treatmentUUID, remotetreatmentconfigurationId } =
        action.session;
      return {
        ...state,
        selectedSession: {
          ...state.selectedSession,
          clientId,
          treatmentUUID,
          remotetreatmentconfigurationId,
        },
        isLoading: false,
      };
    case sessionConstants.CLEAR_SELECTED_SESSION:
      return {
        ...state,
        selectedSession: null,
      };
    case sessionConstants.CLEAR_SESSIONSDATA:
      return {
        ...state,
        data: [],
      };

    case sessionConstants.POLL_SUCCESS: {
      const nextSession = action.session;

      if (isEqual(state.selectedSession, nextSession)) return state;

      return {
        ...state,
        selectedSession: nextSession,
      };
    }
    default:
      return state;
  }
}
